import * as React from 'react';
import Box from '@mui/material/Box';
import { motion, useReducedMotion } from 'framer-motion';

const MotionBox = motion(Box);

const directions = {
  up: { x: 0, y: 48 },
  down: { x: 0, y: -48 },
  left: { x: 48, y: 0 },
  right: { x: -48, y: 0 },
  none: { x: 0, y: 0 },
};

/**
 * Fades/slides its children into view once, when scrolled into the viewport.
 */
export default function Reveal({
  children,
  direction = 'up',
  delay = 0,
  duration = 0.7,
  amount = 0.3,
  once = true,
  sx,
  ...props
}) {
  const reduceMotion = useReducedMotion();
  const offset = directions[direction] || directions.up;

  const hidden = reduceMotion
    ? { opacity: 0 }
    : { opacity: 0, x: offset.x, y: offset.y };
  const visible = { opacity: 1, x: 0, y: 0 };

  return (
    <MotionBox
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount }}
      variants={{ hidden, visible }}
      transition={{
        duration: reduceMotion ? 0.3 : duration,
        delay: reduceMotion ? 0 : delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      sx={sx}
      {...props}
    >
      {children}
    </MotionBox>
  );
}
